/**
 * Copyright (c) NCR Terafina
 **/
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { AuthService } from './AuthService';

interface PropsType {
  children: JSX.Element;
  path: string;
  location?: Location;
}
type PropsState = { isLoading: boolean; isLoggedIn: boolean };
/**
 * Guarding router
 */
export default class GuardedRoute extends React.Component<PropsType, PropsState> {
  constructor(props: PropsType) {
    super(props);

    this.state = {
      isLoading: true,
      isLoggedIn: false,
    };
  }

  componentDidMount() {
    AuthService.validate().then((resp) => {
      if (resp) {
        this.setState(() => ({ isLoading: false, isLoggedIn: true }));
      } else {
        this.setState(() => ({ isLoading: false, isLoggedIn: false }));
      }
    });
  }

  render() {
    return this.state.isLoading ? null : this.state.isLoggedIn ? (
      <Route path={this.props.path}> {this.props.children} </Route>
    ) : (
      <Redirect to={{ pathname: '/login', state: { from: this.props.location } }} />
    );
  }
}
